/* ADMINISTRADOR */

export const Dashboard = {
  text: "sidebar.inicio",
  link: "/home",
  img: "home.svg",
  icon: "",
  available: true
};

export const Admins = {
  text: "sidebar.admins",
  link: "/administrador",
  img: "admins.svg",
  icon: "",
  available: true
};

export const Clients = {
  text: "sidebar.clientes",
  link: "/clientes",
  img: "clients.svg",
  height: "16px",
  icon: "",
  available: true
};
export const Waterwises = {
  text: "sidebar.waterwise",
  icon: "",
  img: "waterwise.svg",
  permission: "view_waterwise",
  submenu: [
    {
      icon: "",
      text: "sidebar.waterwise-brands",
      link: "/configuracion-waterwise",
      img: "admin-waterwise.svg",
      available: true
    },
    {
      icon: "",
      text: "sidebar.waterwise-control",
      link: "/waterwise",
      img: "control-waterwise.svg",
      available: true
    },
    {
      icon: "",
      text: "sidebar.waterwise-creation",
      link: "/warehouse-device/waterwises",
      img: "creacion-waterwise.svg",
      available: true
    },
    {
      icon: "",
      text: "sidebar.waterwise-sensor-calibration",
      link: "/calibracion-waterwise",
      img: "calibracion-waterwise.svg",
      available: true
    }
  ]
};

/* Iconos temporales de waterwise hasta tener los de hidrofono */
export const Hydros = {
  text: "sidebar.hydros",
  icon: "",
  img: "waterwise.svg",
  submenu: [
    {
      icon: "",
      text: "sidebar.hydro-brands",
      link: "/configuracion-hidrofono",
      img: "admin-waterwise.svg",
      available: true
    },
    {
      icon: "",
      text: "sidebar.hydro-management",
      link: "/hidrofonos",
      img: "control-waterwise.svg",
      available: true
    }
  ]
};

export const FeedersControls = {
  text: "sidebar.alimentadores",
  icon: "",
  img: "feeders.svg",
  submenu: [
    {
      icon: "",
      text: "sidebar.dosifiers-brands",
      link: "/inicio-alimentadores",
      img: "feeders_admon.svg",
      available: true
    },
    {
      icon: "",
      text: "sidebar.control-feeders",
      link: "/alimentadoras",
      img: "feeders_control.svg",
      available: true
    },
    {
      icon: "",
      text: "sidebar.feeders-creation",
      link: "/warehouse-device/feeders",
      img: "feeders_plant.svg",
      available: true
    },
    {
      icon: "",
      text: "sidebar.calibration",
      link: "/calibration",
      img: "calibration.svg",
      permission: "calibration",
      available: true
    }
  ]
};

export const Food = {
  icon: "",
  img: "food.svg",
  text: "sidebar.alimentos",
  link: "/inicio-alimento",
  available: true
};

export const TrayTemplates = {
  icon: "",
  img: "trays.svg",
  text: "sidebar.charolas",
  link: "/plantillas-de-charolas",
  available: true
};

export const Maintenance = {
  text: "sidebar.monitoreo",
  link: "",
  icon: "",
  img: "monitor.svg",
  submenu: [
    {
      icon: "",
      text: "sidebar.alertas",
      link: "/alerts",
      img: "alerts.svg",
      available: true
    },
    {
      text: "sidebar.reports",
      link: "/monitoring-reports",
      img: "",
      height: "16px",
      icon: "fas fa-file-contract",
      available: true
    },
    {
      icon: "",
      img: "eye.svg",
      text: "supervision",
      link: "/supervision",
      available: true
    }
  ]
};

export const MovementsHistorical = {
  text: "sidebar.movimientos",
  link: "/historial-de-movimientos",
  icon: "",
  img: "movements.svg",
  available: true
};

export const MainNavigation = {
  text: "Main Navigation",
  heading: true
};

export const Apks = {
  text: "sidebar.apks",
  link: "/apks",
  img: "",
  height: "16px",
  icon: "fa fa-mobile",
  available: true
};

export const Notifications = {
  icon: "fas fa-bell",
  text: "sidebar.notifications",
  link: "/notificaciones",
  img: "",
  available: true
};

export const Calibration = {
  icon: "",
  text: "sidebar.calibration",
  link: "/calibration",
  img: "calibration.svg",
  available: true
};

export const Region = {
  icon: "",
  text: "sidebar.region",
  link: "/regiones",
  img: "farm.svg",
  available: true
};

export const AdminDietsMenu = {
  icon: "",
  text: "sidebar.diets-list",
  link: "/dietas-administrativas",
  img: "diets.svg",
  available: true
};

export const Organization = {
  icon: "fa fa-building",
  text: "sidebar.organization",
  link: "/organizacion",
  img: "",
  available: true
};

export const Restore = {
  icon: "fa fa-database",
  text: "sidebar.restaurar",
  link: "/restaurar",
  img: "",
  available: true
};

export const Planes = {
  icon: "fa fa-list-alt",
  text: "sidebar.planes",
  link: "/planes",
  img: "",
  available: true
};
